
import { Options } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import FormMixin from "../../helpers/mixins/form";
import { DepartmentApi, Department, IdName as NodePaths } from "../../autogen";
import { Field, Form } from "vee-validate";
import FieldLabel from "../atoms/FieldLabel.vue";
import * as yup from "yup";
import FieldError from "../atoms/FieldError.vue";
import FormError from "../atoms/FormError.vue";
import ActionButton from "@/components/atoms/ActionButton.vue";
import { NodeData } from "@/components/molecules/tree/interface";
type FormValues = { name: string; parentId: string };

@Options({
  components: { Field, Form, FieldLabel, FieldError, ActionButton, FormError }
})
export default class DepartmentForm extends FormMixin {
  @Prop({ type: Object }) department?: Department;
  @Prop({ type: Object }) parents?: NodeData | null = null;
  @Prop({ type: Object }) nodePaths?: NodePaths[];
  formName = "部署";
  formValues: FormValues = {
    name: "",
    parentId: "none"
  };
  validationSchema!: yup.AnyObjectSchema;
  beforeCreate() {
    this.validationSchema = yup.object({
      name: yup
        .string()
        .trim()
        .required(this.$t("input_required", { field: "部署名" })),
      parentId: yup
        .string()
        .trim()
        .required(this.$t("input_required", { field: "親組織" }))
    });
  }
  beforeMount() {
    if (this.department) this.formValues = { name: this.department.name, parentId: this.parents?.id || "none" };
  }
  async onBeforeSubmit(values: FormValues) {
    await this.onSubmit(async () => {
      if (this.department) {
        await new DepartmentApi().updateDepartment({
          updateDepartmentRequest: Object.assign(values, {
            parentId: values.parentId === "none" ? "" : values.parentId
          }),
          departmentId: this.department.id
        });
      } else {
        await new DepartmentApi().createDepartment({
          createDepartmentRequest: Object.assign(values, {
            parentId: values.parentId === "none" ? "" : values.parentId
          })
        });
      }
      this.$emit("submitted");
    });
  }
  async onDeleteButtonClick() {
    this.onDelete(async () => {
      await new DepartmentApi().deleteDepartment({
        departmentId: this.department!.id
      });
    }, [
      "削除された部署は元に戻せません",
      "配下部署も一括削除されます。削除してよろしいですか？",
      "※配下部署を含む部署に従業員、応募者が所属している状態では削除できません。"
    ]);
  }
}
